module.exports = __webpack_public_path__ + "static/mobile-money-a23384c0f40a9ddaa1f3f62626ccf9f7.svg";